<template>
  <div class="secondaryNavigation">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <router-link class="nav-link" :to="'/'+this.$store.state.language+'/supplier/dashboard'">{{t('Dashboard')}}</router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" :to="'/'+this.$store.state.language+'/admin/users'">{{t('Users')}}</router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" :to="'/'+this.$store.state.language+'/admin/activities'">{{t('Activities')}}</router-link>
      </li>
      <li class="nav-item"><router-link class="nav-link" :to="`/${this.$store.state.language}/admin/bookings`">{{t('Bookings')}}</router-link></li>
      <!--li class="nav-item"><router-link class="nav-link" :to="'/'+$store.state.language+'/admin/activities/calendar'">{{t('Calendar')}}</router-link></li-->
      <li class="nav-item"><router-link class="nav-link" :to="'/'+this.$store.state.language+'/admin/payments'">{{t('Payments')}}</router-link></li>
    </ul>
  </div>
</template>

<script>

  export default {
    name: 'SecondaryNavigation',
    components: {},
    data() {
      return {
      };
    },
    computed: {
    },
  };
</script>

<style lang="scss" scoped>
  .secondaryNavigation {
    clear: both;
    width: 100%;
    .nav {
      padding-top: 8px;
      padding-bottom: 15px;
      padding-left: 30px;
      padding-right: 30px;
      background-color: lighten(#00695C, 5%);
      min-height: 50px;
      li {
        display: inline-block;
        a {
          color: white;
        }
      }
    }
  }
  .text-muted {
    color: rgba(white, 0.5) !important;
  }
</style>



// WEBPACK FOOTER //
// SecondaryNavigation.vue?40a8fca8